module.exports = __webpack_public_path__ + "img/kommune-101.821ca7a5.svg";